import { DataTable, TableProvider } from "@xest-ui/data-table";
import MyPaginator from "components/PaginatedTable/MyPaginator";
import { DefaultTableComponents } from "components/PaginatedTable/DefaultTableComponents";
import { useHistory, useLocation } from "react-router-dom";
import updateQueryParams from "components/PaginatedTable/updateQueryParams";
import React from "react";
import { camelCase, mapKeys } from "lodash";
import getDigibasicTools from "services/getDigibasicTools";

const LatestSubmissionsTable = (props) => {
  const history = useHistory();
  const location = useLocation();
  const {
  setFeedRateToolId,
  setSelectedToolData,
  setClickedRowIndex,
  onExportHistory,
  canExport,
} = props;
  const toCamelCase = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map((v) => toCamelCase(v));
    } else if (obj !== null && obj.constructor === Object) {
      return mapKeys(obj, (value, key) => camelCase(key));
    }
    return obj;
  };

  const cols = [
    {
      dataIndex: "tool_input_ref_no",
      title: "Reference No",
      filterType: {
        dbCol: "digibasic_tools.tool_input_ref_no",
        type: "string",
      },
      width: 40,
      ellipsis: { showTitle: true },
    },
    {
      dataIndex: "created_at",
      title: "Created At",
      filterType: {
        dbCol: "digibasic_tools.created_at",
        type: "date",
      },
      width: 40,
      ellipsis: { showTitle: true },
    },
    {
      title: "Actions",
      fixed: "right",
      width: 15,
      render(record) {
        return (
          <button
            type="button"
            className="btn btn-info btn-sm"
            style={{ width: "7em", cursor: "pointer" }}
            onClick={() => {
              const { digibasic_tool_id } = record;
              setFeedRateToolId(digibasic_tool_id);
              setSelectedToolData(toCamelCase(record));
              setClickedRowIndex(record.digibasic_tool_id);
            }}
          >
            Show Data
          </button>
        );
      },
    },
  ];
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px",
          marginBottom: "12px",
        }}
      >
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={onExportHistory}
          disabled={!canExport}
        >
          Export Full Data
        </button>
      </div>

      <TableProvider
        params={{
          apiCallFn: async function (queryParams) {
            const res = await getDigibasicTools({ queryParams });
            return {
              data: res.data,
              total: res.data?.metadata?.total || 0,
            };
          },
          initialPageSize: 5,
          config: {
            tableIdentifier: "get-digibasic-tools-table",
            updateSearchQueryParams(newParams) {
              updateQueryParams({
                history,
                location,
                newParams,
              });
            },
          },
          initialSortCriteria: "-digibasic_tools.created_at",
          deps: [],
        }}
        components={DefaultTableComponents}
        columns={cols}
      >
        <DataTable pagination={false} />
        <MyPaginator />
      </TableProvider>
    </div>
  );
};

export default LatestSubmissionsTable;
